// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TpRUmJXxLeEhi0el7kJN{padding:16px 24px 24px 24px}`, "",{"version":3,"sources":["webpack://./src/pages/clickToText/pages/all/ui/ClickToTextModals/styles.module.scss"],"names":[],"mappings":"AAAA,sBACE,2BAAA","sourcesContent":[".wrap {\n  padding: 16px 24px 24px 24px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `TpRUmJXxLeEhi0el7kJN`
};
export default ___CSS_LOADER_EXPORT___;
